module.exports = ".l_p_img a {\n  cursor: pointer; }\n"